import React, { useCallback, useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";

import { BaseUrl } from "../../common/FormatHelper";

import DataGroup from "../../components/DataGroup/DataGroup";
import PracticeAddresses from "../../components/Practices/PracticeAddresses/PracticeAddresses";
import PracticeFlags from "../../components/Practices/PracticeFlags/PracticeFlags";
import PracticeHeader from "../../components/Practices/PracticeHeader/PracticeHeader";
import PracticeHospitalAffiliations from "../../components/Practices/PracticeHospitalAffiliations/PracticeHospitalAffiliations";
import PracticeLanguages from "../../components/Practices/PracticeLanguages/PracticeLanguages";
import PracticeProviders from "../../components/Practices/PracticeProviders/PracticeProviders";

import Loader from "react-loader-spinner";
import axios from "axios";

const api = axios.create({
	baseURL: BaseUrl(),
});
  
const PracticeProfile = (props) => {
	const params = useParams();

	const [practice, setPractice] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState(null);

	const fetchPracticeData = useCallback(async (practice_id) => {
		setIsLoading(true);
		setError(null);

		try {
			const response = await api.get(`/v3/practices/${practice_id}`);
			setPractice(response.data.practice);
		} catch (ex) {
			setError(ex.message);
		} finally {
			setIsLoading(false);
		}
	}, []);

	useEffect(() => {
		fetchPracticeData(params.id);
	}, [fetchPracticeData]);

	let content = <Loader type="Oval" color="#00BFFF" height={100} width={100} timeout={10000} className="loader" />;

	if(!isLoading) {
		if(error) {
			content = <Card><Card.Body>{error}</Card.Body></Card>;
		} else if(practice === null) {
			content = <Card><Card.Body>No practice found!</Card.Body></Card>;
		} else {
			content = (
				<Container>
					<Row>
						<Col span={12}>
							<PracticeHeader practice={practice}>{practice.practice_name}</PracticeHeader>
						</Col>
					</Row>
					<Row>
						<Col span={6}>
							<DataGroup title="Addresses">
								<PracticeAddresses addresses={practice.addresses} />
							</DataGroup>
						</Col>
						<Col span={6}>
							<DataGroup title="Flags">
								<PracticeFlags practice={practice} />
							</DataGroup>
						</Col>
					</Row>
					<Row>
						<Col span={12}>
							<PracticeProviders providers={practice.providers} />
						</Col>
					</Row>
					<Row>
						<Col span={6}>
							<DataGroup title="Languages">
								<PracticeLanguages languages={practice.languages} />
							</DataGroup>
						</Col>
						<Col span={6}>
							<DataGroup title="Hospitals">
								<PracticeHospitalAffiliations hospitals={practice.hospital_affiliations} />
							</DataGroup>
						</Col>
					</Row>
				</Container>
			);
		}
	}

	return content;
}

export default PracticeProfile;